export const AutomationFieldType = {
  ASSOCIATIONS_TEAM_PROPERTY_INPUT: 'ASSOCIATIONS_TEAM_PROPERTY_INPUT',
  AUTOMATED_EMAIL: 'AUTOMATED_EMAIL',
  AUTOMATED_SMS: 'AUTOMATED_SMS',
  OBJECT_PROPERTY: 'OBJECT_PROPERTY',
  OWNER_PROPERTY: 'OWNER_PROPERTY',
  PROPERTY_INPUT: 'PROPERTY_INPUT',
  ROUTING_TEAMS: 'ROUTING_TEAMS',
  SINGLE_OBJECT_COORDINATES: 'SINGLE_OBJECT_COORDINATES',
  SKILLS: 'SKILLS',
  STEPPER: 'STEPPER',
  WHATSAPP_TEMPLATE: 'WHATSAPP_TEMPLATE'
};